import $ from 'jquery';
/**
 * Class to render google map for tour page
 * @returns {googleMap}
 *
 */

export const googleMap = () => {
    let infowindow;
    var centerPoint=null;
    var zoomLevel=3;
    var map = null;
    var mapType='terrain';

    var tours= new Array();

    let minLat= null;
    let maxLat= null;
    let minLong= null;
    let maxLong= null;

    const canvasDom = $("#map_canvas");

    const collectData = () => {
    	const eventDataDom= document.querySelectorAll('[data-event]');
    	for(let i=0;i<eventDataDom.length;i++){
    		try {
	    		const eventData = JSON.parse($(eventDataDom[i]).attr("data-event"));
	    		eventData.lat = parseFloat(eventData.lat);
	    		eventData.long = parseFloat(eventData.long);
	    		tours.push(eventData);
	    		if(minLat== null || eventData.lat< minLat){
	    			minLat= eventData.lat;
	    		}
	    		if(maxLat== null || eventData.lat> maxLat){
	    			maxLat= eventData.lat;
	    		}
	    		if(minLong== null || eventData.long< minLong){
	    			minLong= eventData.long;
	    		}
	    		if(maxLong== null || eventData.long> maxLong){
	    			maxLong= eventData.long;
	    		}
    		} catch(err){

    		}

    	}


    };


    /**
     * Zoom in
     */
	const fullMap = () => {
        if (map ) {
            map.setMapTypeId(google.maps.MapTypeId.TERRAIN);
            map.setZoom(zoomLevel);
            map.setCenter(centerPoint);
            infowindow.close();
        }

    }

    /**
     * Render map using tour date array
     */
	const renderGoogleMap = () => {

        if(canvasDom.length > 0){
            mapType='terrain';
            if(parseFloat(maxLong) ==  parseFloat(minLong)){
                zoomLevel= 10;
                mapType='roadmap';
                centerPoint = new google.maps.LatLng((parseFloat(maxLat) + parseFloat(minLat))/2 , (parseFloat(maxLong) +  parseFloat(minLong))/2);//auto center
            }else{
                centerPoint = new google.maps.LatLng((parseFloat(maxLat) + parseFloat(minLat))/2 , (parseFloat(maxLong) +  parseFloat(minLong))/2);;
                if(Math.abs(parseFloat(maxLong) -  parseFloat(minLong))<40){
                    zoomLevel=3;
                    mapType='terrain';
                }
                else if(Math.abs(parseFloat(maxLong) -  parseFloat(minLong))<60){
                    zoomLevel=3;
                    mapType='terrain';
                }
                else if(Math.abs(parseFloat(maxLong) -  parseFloat(minLong))<130){
                    zoomLevel=2;
                    mapType='terrain';
                }else{
                    zoomLevel=3;
                    mapType='terrain';
                }
            }

            //initialize  infowindow
            infowindow = new google.maps.InfoWindow({
                content: "<LOADING>"
            });
            // make sure closing via the [x] also goes back to full map view
            google.maps.event.addListener(infowindow, 'closeclick', function() {
                map.setMapTypeId(google.maps.MapTypeId.TERRAIN);
                //
                //map.setCenter(centerPoint);
                map.setZoom(3);
                map.close();
            });
            //STARTING OF MAP 1
            map = new google.maps.Map(document.getElementById('map_canvas'), {
                center:centerPoint,
                zoom: zoomLevel,
                mapTypeId: mapType,
                scrollwheel: false

            });








            /* High and low points of map */
            // Prepares the marker object, creating a google.maps.Marker object for each
            let marker;
            for (var venues = 0; venues < tours.length; venues++) {
                if (tours.length == 1) {
                    var infoContent = "";
                }else{
                	/*
                	var infoContent= `
           			 <div style='text-transform:capitalize; padding-right: 15px; font-size: 14px; color: #000000;'>
        			    	${tours[venues].tour_name} <br />
                			${tours[venues].show_date} :  ${tours[venues].name}
                		</div>
                			${tours[venues].address1} <br />
                			${tours[venues].address2} <br />
                			${tours[venues].city} <br />
                			${tours[venues].state} <br />
                			${tours[venues].country} <br /><br/>
                			<a style='text-decoration:none;padding:2px;background-color:#ff0000;color:#ffffff' href='/tour/date/${tours[venues].tour_date_id}'>
                				Event Detail Page &raquo;
            				</a><br/><br />
            				<a target='_blank' style='color:#ff0000;text-decoration:none' href='https://maps.google.com/maps?daddr=${tours[venues].lat},${tours[venues].long}+(${tours[venues].name})'>
            					Get directions &raquo;
        					</a>
        					&nbsp;&nbsp;&nbsp;&nbsp; <a style='color:#ff0000;text-decoration:none' onclick='fullMap();'>Back to full map &raquo;</a>
        			`;
                	*/


                    var infoContent = "<div style='text-transform:capitalize; padding-right: 15px; font-size: 14px; color: #000000;'>"
                        + tours[venues].tour_name + "<br />"
                        + tours[venues].show_date + " : " + tours[venues].name
                        + "</div>";
                    if ( tours[venues].address1 ) { infoContent += tours[venues].address1 + "<br/>"; }
                    if ( tours[venues].address2 ) { infoContent += tours[venues].address2 + "<br/>"; }

                    if ( tours[venues].city || tours[venues].state || tours[venues].country ) {
                        var csc;
                        if ( tours[venues].city ) { csc = tours[venues].city; }
                        if ( tours[venues].state ) {
                            if ( csc ) csc += ", ";
                            csc += tours[venues].state;
                        }
                        if ( tours[venues].country ) {
                            if ( csc ) csc += ", ";
                            csc += tours[venues].country;
                        }
                        infoContent += csc + "<br/>";
                    }

                    infoContent += "<br/><a style='text-decoration:none;padding:2px;background-color:#ff0000;color:#ffffff' href='/tour/date/"
                        + tours[venues].tour_date_id
                        + "'>Event Detail Page &raquo;</a><br/>";

                    infoContent += "<br><a target='_blank' style='color:#ff0000;text-decoration:none' href='https://maps.google.com/maps?daddr="
                        + tours[venues].lat + "," + tours[venues].long
                        + "+(" + tours[venues].name + ")"
                        + "'>Get directions &raquo;</a>";

                    infoContent += " &nbsp;&nbsp;&nbsp;&nbsp; <a style='color:#ff0000;text-decoration:none' id='btnBackToFullMap'>Back to full map &raquo;</a>";


                }

                /*End of Map detail*/

                marker = new google.maps.Marker({
                    map: map,
                    position: new google.maps.LatLng(tours[venues]['lat'], tours[venues]['long']),
                    clickable: false,
                    draggable: true,
                    flat: true,
                    title: tours[venues].tour_name + " : " + tours[venues].show_date + " @ " + tours[venues].name + ", " + tours[venues].city + ", " + tours[venues].country,
                    infoContent: infoContent,
                    myself: $(this)
                });
                google.maps.event.addListener(marker, 'click', function() {
                    map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
                    map.setZoom(8);
                    map.setCenter(this.position);

                    infowindow.setContent(this.infoContent);

                    infowindow.open(map,this);
                    //document.getElementById("mapBack2Full").addEventListener("click", fullMap, true);
                    setTimeout(function(){
                    	document.getElementById("btnBackToFullMap").addEventListener("click", fullMap, true);
                    },1000);
                });


            }
            //END OF MAP1


        }
    }



	if(canvasDom.length>0){
		collectData();
	    renderGoogleMap();
	}
    //fullMap();
}